import script from "./CollectionNameField.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionNameField.vue?vue&type=script&setup=true&lang=js"

export default script